// extracted by mini-css-extract-plugin
export var phone = "_36-0";
export var phoneDragging = "_36-1";